import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack?',
  answer: 'Al confirmar el pago recibís el acceso en tu email. En menos de 5 minutos tenés todo disponible.'
}, {
  question: '2 — ¿Sirve para profes particulares o solo instituciones?',
  answer: 'Para los dos. Hay material para el profe de una sola escuela y para el "profe taxista" de 5 instituciones.'
}, {
  question: '3 — ¿Sirve si soy profe nuevo?',
  answer: 'Especialmente para vos. Tenés la consigna exacta, el tiempo y el objetivo. Es como tener un colega con 10 años de experiencia susurrándote qué hacer.'
}, {
  question: '4 — ¿Sirve para alumnos de todas las edades?',
  answer: 'Sí. Desde los 3 años (Inicial) hasta adultos de cualquier edad (Tomo 6).'
}, {
  question: '5 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos están incluidos en ambas opciones sin costo extra.'
}, {
  question: '6 — ¿Tiene garantía real?',
  answer: '7 días, sin preguntas, sin formularios. Si no es lo que esperabas, te devolvemos todo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-115">
      <div className="max-w-3xl mx-auto" data-id="element-116">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-117">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-118">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#FFD700] bg-[#0d0a00]' : 'border-[#FFD700]/20 bg-black'}`} data-id="element-119">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-120">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-121">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#FFD700] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-122">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-123">
                  <div className="h-px bg-[#FFD700]/20 mb-4" data-id="element-124" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-125">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}